import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=d7195b8c&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=d7195b8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7195b8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d7195b8c')) {
      api.createRecord('d7195b8c', component.options)
    } else {
      api.reload('d7195b8c', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=d7195b8c&scoped=true&", function () {
      api.rerender('d7195b8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jFz1hjAla5SR/JS/comp/SearchFilterTokens.vue"
export default component.exports